const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 15.304 15.304",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B1CE"
    },
    d: "M5.734,8.248V7.617C5.382,7.377,5.049,7.092,4.742,6.754c-0.889,0.859-1.74,1.403-1.836,1.464 L2.825,8.268l-0.49-0.783l0.08-0.051c0.01-0.007,0.876-0.556,1.751-1.413C3.363,4.85,3.054,3.67,3.042,3.619l-0.023-0.09 l0.895-0.23L3.936,3.39C3.938,3.4,4.193,4.344,4.813,5.316c0.613-0.745,0.97-1.463,1.061-2.14H2.115V2.171h2.072V1.612h0.966 v0.558h2.072v1.006H6.808C6.711,4.117,6.233,5.092,5.384,6.077c0.114,0.128,0.231,0.245,0.35,0.357V6.369V5.961 c0-0.336,0.272-0.608,0.608-0.608h2.705V0.569c0-0.084-0.067-0.152-0.152-0.152H0.152C0.068,0.417,0,0.485,0,0.569v8.742 c0,0.085,0.068,0.152,0.152,0.152h5.582L5.734,8.248L5.734,8.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B1CE"
    },
    d: "M10.728,8.515h-0.017c-0.084,0.333-0.166,0.755-0.258,1.078l-0.332,1.187h1.236L11.01,9.593 C10.91,9.261,10.81,8.847,10.728,8.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B1CE"
    },
    d: "M15.152,5.841H6.41c-0.084,0-0.152,0.068-0.152,0.152v8.743c0,0.084,0.068,0.151,0.152,0.151 h8.742c0.085,0,0.152-0.067,0.152-0.151V5.993C15.304,5.91,15.237,5.841,15.152,5.841z M11.972,13.16l-0.431-1.436H9.94 L9.541,13.16h-1.31L9.94,7.57h1.658l1.733,5.59H11.972z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A8B1CE"
    },
    points: "3.935,9.846 2.72,9.846 2.72,11.866 3.726,12.862 5.986,12.862 5.986,11.647  3.935,11.647  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchLanguage);
export default __webpack_public_path__ + "static/media/switchLanguage.782275542e022db8fbad81cbd3db6422.svg";
export { ForwardRef as ReactComponent };